import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { React } from 'react';
import FiltersProvider from '@accrosoft-ltd/vf-careers-site-theme/src/context/smartfeed/FiltersContext';
import { jsx as _jsx } from "react/jsx-runtime";
export var onClientEntry = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            require('babel-polyfill');

            require('whatwg-fetch');

            if (!(typeof IntersectionObserver === "undefined")) {
              _context.next = 5;
              break;
            }

            _context.next = 5;
            return import("intersection-observer");

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function onClientEntry() {
    return _ref.apply(this, arguments);
  };
}();
export var wrapRootElement = function wrapRootElement(_ref2) {
  var element = _ref2.element;
  return /*#__PURE__*/_jsx(FiltersProvider, {
    children: element
  });
};